module.exports = __webpack_public_path__ + "img/benefit-curve-tablet.4788fcc3.svg";